import React from "react"

const FireIcon = () => {
  return (
    <svg
      style={{ height: '19px'}}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_14808_6359)">
        <path
          d="M10.6935 16.174C13.2985 15.6779 16.6665 13.8977 16.6665 9.29427C16.6665 5.10511 13.4388 2.31553 11.1178 1.03376C10.6028 0.749338 9.99988 1.12339 9.99988 1.68932V3.13686C9.99988 4.27834 9.49469 6.36189 8.09098 7.22852C7.37431 7.67098 6.60031 7.00874 6.51321 6.20099L6.44169 5.53771C6.35854 4.76662 5.53189 4.29852 4.88317 4.76865C3.71777 5.61323 2.49988 7.09219 2.49988 9.29427C2.49988 14.9239 6.90729 16.3313 9.11099 16.3313C9.23917 16.3313 9.37387 16.3277 9.5141 16.32C8.42597 16.2316 6.66654 15.5903 6.66654 13.5163C6.66654 11.8939 7.91244 10.7963 8.85906 10.2628C9.11366 10.1193 9.41164 10.3056 9.41164 10.5869V11.0533C9.41164 11.4103 9.55697 11.9683 9.90291 12.3503C10.2944 12.7825 10.869 12.3297 10.9153 11.7612C10.9299 11.5819 11.1198 11.4676 11.2833 11.5583C11.8177 11.8551 12.4999 12.4889 12.4999 13.5163C12.4999 15.1376 11.5591 15.8834 10.6935 16.174Z"
          fill="url(#paint0_linear_14808_6359)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_14808_6359"
          x1="9.58321"
          y1="0.936279"
          x2="9.58321"
          y2="16.3313"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDDE70" />
          <stop offset="1" stopColor="#DC5C16" />
        </linearGradient>
        <clipPath id="clip0_14808_6359">
          <rect
            width="20"
            height="19"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default FireIcon
